<template>
  <transition name="fade">
    <div class="modal-overlay" @click.self="close">
      <div class="modal-content shadow">
        <div class="tos-text-container" >
          <div class=WordSection1>

<p class=MsoNormal align=center style='text-align:center'><b><span lang=EN-CA
style='font-size:14.0pt;line-height:107%'>Enable viewing of Hydrasurvey 3D content in PDF
documents with Adobe Reader</span></b></p>

<p class=MsoNormal align=center style='text-align:center'><b><span lang=EN-CA>
When you open a PDF with 3D content, you see a yellow bar at the top with the
message - <br/>"3D content has been disabled. Enable this features if you trust this
document."
</span></b></p>

<p class=MsoNormal align=center style='text-align:center'>
To enable 3D content in the current document:<br/>
</p>
Click the Options button and then select an appropriate option:
    <ul>
        <li>Trust this document one time only</li>
        <li>Trust this document always</li>
    </ul>

   <p>
       To enable 3D content permanently:</p>>
       <ul>
        <li>Go to Edit > Preferences > 3D & Multimedia and then select the Enable playing 3D content checkbox.</li>
        <li><strong>PRO TIP</strong>: To turn lighting on or off or to change lighting, choose an option from the
            Enable Extra Lighting pop-up menu . The Bright Lights setting really brightens up the
            entire model.
        </li>>
    </ul>

<p class=MsoNormal align=center style='text-align:center'>
For more information on viewing 3D PDFs in Adobe Reader, visit
https://helpx.adobe.com/acrobat/using/displaying-3d-models-pdfs.html.
</p>

          </div> 
        </div> 
      </div> 
    </div>  
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';
const emit = defineEmits(['accepted','close3dhelp']);
const isVisible = ref(false);
const hasReadToBottom = ref(false);
const tosContainer = ref(null);

const close = () => {
    emit('close3dhelp');
};

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px; /* Gives some breathing room on mobile */
}

.modal-content {
  background: white;
  padding-top:10px;
  padding-right: right 0px;
  padding-left: 5px;
  border-radius: 12px;
  max-width: 600px; /* Better for reading long text */
  width: 100%;
  max-height: 90vh; /* Limits height to 90% of the screen */
  display: flex;
  flex-direction: column; /* Stacks title, text, and button */
  text-align: left; /* Reading a million miles of centered text is hard */
}

/* Add a wrapper around your long text in the template */
.tos-text-container {
  overflow-y: auto; /* This creates the scrollbar */
  margin-bottom: 20px;
  padding-right: 10px; /* Space so text doesn't touch the scrollbar */
  flex-grow: 1; /* Makes this part take up the available space */
}

.btn-confirm {
  flex-shrink: 0; /* Ensures the button doesn't get squashed */
  width: 100%;
  background: #27ae60;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
}
</style>